import { Injectable } from "@angular/core";
import { 
  HttpEvent, HttpInterceptor, HttpHandler,
  HttpRequest, HttpErrorResponse, HttpClient
} from "@angular/common/http";
import { throwError, Observable, BehaviorSubject, of, EMPTY,timer } from "rxjs";
import { catchError, filter, take, switchMap, finalize, retryWhen, mergeMap } from "rxjs/operators";
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private AUTH_HEADER = "Authorization";
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private httpClient: HttpClient){}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    req = this.addAuthenticationToken(req);

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Let the component handle all errors including 401/403 for proper auth0 logout
        return throwError(error);
      })
    );
  }

  private refreshAccessToken(): Observable<any> {   
      const payload = {
          "grant_type": "refresh_token",
          "client_id": environment.passport.client_id,
          "client_secret": environment.passport.client_secret,
          "refresh_token": localStorage.getItem('refreshToken')
      };
      return this.httpClient.post<any>(
          environment.authUrl + '/oauth/token',
          payload);
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    // If we do not have a token yet then we should not set the header.
    // Here we could first retrieve the token from where we store it.
    if (!localStorage.getItem('bearerToken')) {
      return request;
    }

    let impersonate = localStorage.getItem('impersonate');
    const bearerToken = localStorage.getItem('bearerToken');
    let headers = request.headers.set(this.AUTH_HEADER, bearerToken || '');
    if (impersonate) {
      headers = headers.set('x-impersonate', impersonate);
    }
    
    // Set X-Timezone header using IANA timezone (e.g., Asia/Karachi)
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    headers = headers.set('X-timezone', timezone);

    return request.clone({
      headers
    });
  }
}